import * as React from "react";
import classNames from "classnames";
import classes from "./Spinner.styl";


export interface ISpinnerProps {
    className?: string;
    size?: "16" | "32";
}

export const Spinner = ({className, size = "16"}: ISpinnerProps) => {
    return <div className={classNames(
        "circular-loader_svg",
        classes["spinner"],
        classes[`__size-${size}`],
        className)}
    />;
};
